import { Form } from 'factorial-form'
import {
  EditCustomTablePageSchemaFieldValueFragment,
  NewCustomTablePageSchemaFieldFragment,
  NewCustomTablePageSchemaFragment,
} from 'generated/resources/graphql'
import moment from 'moment'

import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { coerceFieldValue } from 'modules/employees/components/CustomResources/SchemaComponent/Form/utils/coerceFieldValue'

import getValueType from './getValueType'

interface Props {
  schema?: NewCustomTablePageSchemaFragment
  field: NewCustomTablePageSchemaFieldFragment
  value?: EditCustomTablePageSchemaFieldValueFragment
}

export const createForm = ({ schema, field, value }: Props): Form => {
  const currentValue = coerceFieldValue(field.fieldType, value)
  const dataValue = () => {
    if (!currentValue) {
      if (schema?.effectiveAtId === field.id) {
        return {
          value: i18nDateToString(moment(), 'backend'),
        }
      } else {
        return {}
      }
    }

    return {
      value: currentValue,
    }
  }

  const name =
    schema?.effectiveAtId === field.id
      ? i18n.t('custom_resources.schema.effective_at_label')
      : field.labelText

  const data = {
    field_id: field.id,
    field_type: field.fieldType,
    // TODO: An schema can have multiple resources for the same attachable (being defined)
    editable: field.editable,
    installed: true,
    mandatory: field.required,
    options: field.options ?? [],
    min_value: field.minValue ?? 0,
    max_value: field.maxValue ?? 10,
    name: name,
    visible: true,
    value_id: value?.id ?? null,
    ...dataValue(),
  }

  return new Form(data, {
    field_id: 'number',
    field_type: 'string',
    resource_id: 'number',
    editable: 'boolean',
    mandatory: 'boolean',
    name: 'string',
    installed: 'boolean',
    options: 'string',
    min_value: 'number',
    max_value: 'number',
    value: getValueType(field.fieldType),
    value_id: 'number',
    visible: 'boolean',
  })
}
